import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import GridComponent from "../../../../../src/component/grid/GridComponent.component";
import { ViewStyled, TextStyled, ViewGraphic, ViewSquar } from "./Graphic";
import { BiCalendar } from 'react-icons/bi';
import { ViewBox } from "../../component/cardComponent/Card";

interface GraphicInterface {
    data: any;
    title: string;
}

export default function Graphic({ data, title }: GraphicInterface) {
    return (
      <ViewStyled>
        <TextStyled>
          {title}
  
          <ViewBox>
            <BiCalendar size={25} style={{ backgroundColor: '#F0F0F5', borderTopLeftRadius: 8, borderBottomLeftRadius: 8, padding: 10, marginRight: 10 }} />
            {'Ultimos 6 meses'}
          </ViewBox>
        </TextStyled>
        <GridComponent justify='flex-start' >
          <ViewGraphic>
            <ResponsiveContainer height={200}>
              <LineChart
                data={data}
                margin={{
                  top: 10,
                  right: 30,
                  left: 0,
                  bottom: 0,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Line type="linear" dataKey="NPS" stroke="#3D3D4C" fill="#3D3D4C" />
              </LineChart>
            </ResponsiveContainer>
          </ViewGraphic>
        </GridComponent>
      </ViewStyled>
    );
  }
